import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { CentralizedGuidelinesForCheckedinLuggage } from "./GuidelinesForCheckedinLuggage";
import { CentralizedSingleCabinLuggagePolicy } from "./SingleCabinLuggagePolicy";

export const CentralizedBaggageGuide = () => {
  const query = useQuery();
  const navigate = useNavigate();
  useEffect(() => {
    if (query.get("id")) {
      return;
    }

    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    if (!activeTab) {
      navigate(
        `/centralized/centralizedBaggageGuide?activeTab=centralizedSingleCabinLuggagePolicy&subActiveTab=centralizedSingleCabinLuggagePolicyPageContent`,
        {
          replace: true,
        }
      );
    } else {
      let defaultSubActiveTab: string | null = null;

      switch (activeTab) {
        case "centralizedSingleCabinLuggagePolicy":
          defaultSubActiveTab = "centralizedSingleCabinLuggagePolicyPageContent";
          break;
        case "centralizedGuidelinesForCheckedinLuggage":
          defaultSubActiveTab = "centralizedGuidelinesForCheckedinLuggagePageContent";
          break;
        default:
          defaultSubActiveTab = "centralizedSingleCabinLuggagePolicyPageContent";
          break;
      }
      navigate(
        `/centralized/centralizedBaggageGuide?activeTab=${activeTab ?? "centralizedSingleCabinLuggagePolicy"}${
          defaultSubActiveTab ? `&subActiveTab=${subActiveTab || defaultSubActiveTab}` : ""
        }`,
        { replace: true }
      );
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);

  const travellersInfoCard = [
    {
      label: "Single Cabin Luggage Policy",
      key: "centralizedSingleCabinLuggagePolicy",
      children: <CentralizedSingleCabinLuggagePolicy />,
    },
    {
      label: "Guidelines for Checked-in Luggage",
      key: "centralizedGuidelinesForCheckedinLuggage",
      children: <CentralizedGuidelinesForCheckedinLuggage />,
    },
  ];

  const handleBaggageGuide = (subActiveTab: any) => {
    if (subActiveTab === "singleCabinLuggagePolicyPageImage") {
      return (
        <Button
          onClick={() => {
            navigate(
              "/centralized/centralizedBaggageGuide/centralizedSingleCabinLuggagePolicy/centralizedSingleCabinLuggagePolicyPageImage/add"
            );
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Page Image
        </Button>
      );
    }
    if (subActiveTab === "centralizedGuidelinesForCheckedinLuggagePageImage") {
      return (
        <Button
          onClick={() => {
            navigate(
              "/centralized/centralizedBaggageGuide/centralizedGuidelinesForCheckedinLuggage/centralizedGuidelinesForCheckedinLuggagePageImage/add"
            );
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Page Image
        </Button>
      );
    }
  };

  return (
    <ContentWrapper
      title={"Baggage Guide"}
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleBaggageGuide(query.get("subActiveTab"))}
      airportText={`Eraman and Passenger`}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={travellersInfoCard}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
